<section class="ki-projekte" aria-labelledby="ki-projekte-titel">
  <div class="ki-projekte__titel">
    <to-section-title
      headingId="ki-projekte-titel"
      [title]="'kiProjektuebersicht.titel' | translate"
      [subtitle]="'kiProjektuebersicht.untertitel' | translate"
    />
  </div>

  @if (loading()) {
    <div
      class="ki-projekte__hinweis ki-projekte__laedt"
      role="status"
      aria-live="polite"
      data-testid="ki-projektuebersicht-laedt"
    >
      <mat-spinner diameter="40"></mat-spinner>
      <span>{{ 'kiProjektuebersicht.laedt' | translate }}</span>
    </div>
  } @else if (loadError()) {
    <p class="ki-projekte__hinweis" role="alert" data-testid="ki-projektuebersicht-fehler">
      {{ 'kiProjektuebersicht.ladefehler' | translate }}
    </p>
  } @else if (projekte().length === 0) {
    <p class="ki-projekte__hinweis" data-testid="ki-projektuebersicht-leer">
      {{ 'kiProjektuebersicht.leer' | translate }}
    </p>
  } @else {
    <div role="table" [attr.aria-label]="'kiProjektuebersicht.titel' | translate">
      <div class="ki-projekte__kopf" role="row" data-testid="ki-projekte-kopf">
        <div class="ki-projekte__name-spalte" role="columnheader">
          {{ 'kiProjektuebersicht.spalte.projekt' | translate }}
        </div>
        <div class="ki-projekte__stand" role="columnheader">{{ 'kiProjektuebersicht.spalte.ki' | translate }}</div>
        <div class="ki-projekte__verbindung" role="columnheader">
          {{ 'kiProjektuebersicht.spalte.verbindung' | translate }}
        </div>
        <div class="ki-projekte__verbrauch" role="columnheader">
          {{ 'kiProjektuebersicht.spalte.verbrauch' | translate }}
        </div>
        <div class="ki-projekte__freigabe" role="columnheader">
          {{ 'kiProjektuebersicht.spalte.freigabe' | translate }}
        </div>
      </div>

      @for (projekt of projekte(); track projekt.projectId) {
        <div
          class="ki-projekte__row"
          [class.ki-projekte__row--gesperrt]="!istFreigegeben(projekt)"
          role="row"
          data-testid="ki-projekt-zeile"
        >
          <div class="ki-projekte__name-spalte ki-projekte__name" role="cell" data-testid="ki-projekt-name">
            {{ projekt.name }}
          </div>
          <div class="ki-projekte__stand" role="cell" data-testid="ki-projekt-stand-zelle">
            <span class="ki-projekte__pill ki-projekte__pill--{{ projekt.stand }}" data-testid="ki-projekt-stand">
              {{ 'kiProjektuebersicht.stand.' + projekt.stand | translate }}
            </span>
          </div>
          <div class="ki-projekte__verbindung" role="cell" data-testid="ki-projekt-verbindung">
            @if (projekt.verbindung; as v) {
              {{ v.anbieter }} ·
              <code class="ki-projekte__modell">{{ v.modell }}</code>
              · {{ v.region }}
            } @else {
              <span class="ki-projekte__ohne">{{ 'kiProjektuebersicht.nichtEingerichtet' | translate }}</span>
            }
          </div>
          <div class="ki-projekte__verbrauch" role="cell" data-testid="ki-projekt-verbrauch">
            {{ verbrauch(projekt.verbrauchTokensMonat) }}
          </div>
          <div class="ki-projekte__freigabe" role="cell" data-testid="ki-projekt-freigabe">
            <button
              type="button"
              role="switch"
              class="ki-projekte__switch"
              [class.ki-projekte__switch--on]="istFreigegeben(projekt)"
              [attr.aria-checked]="istFreigegeben(projekt)"
              [attr.aria-label]="'kiProjektuebersicht.freigebenAria' | translate: { projekt: projekt.name }"
              [disabled]="istPending(projekt)"
              data-testid="ki-projekt-sperren"
              (click)="umschalten(projekt)"
            >
              <span class="ki-projekte__knob" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      }
    </div>
  }
</section>
